/**
 * @fileoverview MicrophoneCheck.module.css
 * Styles for the MicrophoneCheck component.
 */

.error_container,
.container {
    display: flex;
    gap: 1rem;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
}

.container {
    gap: 1.5rem;
}

.progress {
    flex-direction: row;
    justify-content: flex-end;
}

.button_container {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 8px;
    margin: 8px 0 0;
    flex-direction: column-reverse;
    margin-top: auto;
}

@media only screen and (min-width: 768px) {
    .container {
        min-height: 304px;
    }
}
